// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media-file-preview-modal{\n  width: 70vw;\n  height: 100vh;\n}\n", "",{"version":3,"sources":["webpack://./src/components/mediaFiles/list/MediaFileListViewCss.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf","sourcesContent":[".media-file-preview-modal{\n  width: 70vw;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
